const ifPayFaqs = [
	{
		title: 'Hesabım ile ilgili bir sorun oluştu ne yapmalıyım?',
		description: `
			Hesabınızda bir sorunla karşılaştığınızda, "Çözüm Masası" noktamıza gidip destek alabilirsiniz. Ekibimiz en kısa sürede sorununuzu çözmek için çalışacaktır. 
		`,
	},
	{
		title: 'Telefonumun şarjı bittiğinde, uygulamayı kullanmaya devam etmek için ne yapabilirim?',
		description: `
			Telefonunuzun şarjı bittiyse, IF Pay kasa noktalarına gidip QR kart almalısınız. Bu kart sayesinde uygulamayı kullanmaya devam edebilirsiniz, bu nedenle en yakın ödeme noktasına gitmeyi unutmayın. QR kartınızı güvende tutun ve başkalarıyla paylaşmamaya özen gösterin.
		`,
	},
	{
		title: 'Uygulamada QR kodu oluşturmak için ne yapmalıyım?',
		description: `
			Uygulama anasayfasının altında bulunan IF Pay butonuna basmanız yeterli olacaktır. Açılan QR kodu sadece 30 saniye geçerlidir. 30 saniye geçtikten sonra "Yenile" butonunu kullanarak QR kodunuzu yenileyebilirsiniz.
		`,
	},
	{
		title: 'Uygulamadaki hesabıma bakiye yüklemek için hangi adımları izlemeliyim?',
		description: `
			1-Uygulamaya giriş yapın veya uygulamada hesabınıza oturum açın. <br />
			2-Hesabım bölümü kısmında cüzdanım sekmesine tıklayın. <br />
			3- Bakiye yükle butonundan bakiye yüklemek istediğiniz tutarı girin. <br />
			4-Ödeme yapmak istediğiniz kart bilgileri girin ve yükleme yap butonuna basınız. Dilerseniz diğer ödemelerde kart bilgilerini kaydederek ödeme yapabilirsiniz. <br />
		`,
	},
	{
		title: 'Uygulamadaki alışveriş sistemi nasıl çalışmaktadır?',
		description: `
			Uygulamadaki alışveriş sistemi, hesabınıza online kredi kartı ile veya alanda bulunan IF Pay Ödeme noktalarından para yükleyerek çalışır. Yüklediğiniz para, hesabınıza online bakiye olarak aktarılır. Sonrasında istediğiniz ürün veya hizmet için ödeme yapmak için kasa noktalarına gidebilir. Bu noktalarda, uygulamada bulunan size özel ve her alışverişte yenilenen QR kodunu kullanarak alışveriş yapabilirsiniz. QR kodu, ödeme işlemini güvenli ve hızlı bir şekilde tamamlamanızı sağlar. Bu yöntem sayesinde, alışverişlerinizi kolaylıkla gerçekleştirebilir ve uygulamadaki bakiyenizi harcayabilirsiniz.
		`,
	},
	{
		title: 'Festival sonunda uygulamada bakiye kalması durumunda ne olacak?',
		description: `
			1-Festival sonunda, online yükleme yapanlar cüzdanlarında mobil uygulama üzerinden kredi kartı ile yükledikleri bakiyeden harcamadıkları miktarı otomatik olarak kredi kartlarına iade edilecektir. <br />
			2-Yükleme noktasından nakit olarak işlem yapanlar için, etkinlik firması tarafından belirtildiği üzere, nakit yüklemelerden kalan bakiyeler iade edilmemektedir. Bu nedenle, yüklediğiniz tutarı harcamanızı öneririz. <br />
			3-Yükleme noktasından fiziksel kart ile yükleme yapanlar için, etkinlik firmasının belirttiği üzere fiziksel pos ile yapılan yüklemelerden kalan bakiyeler iade edilmemektedir. Bu nedenle, yüklediğiniz tutarı harcamanızı öneririz. <br />
		`,
	},
	{
		title: 'Hava Durumu',
		description: `
			Aksi bir durum belirtmediğimiz sürece her türlü hava koşulunda gerçekleşecektir.
		`,
	},
	{
		title: 'Otopark',
		description: `
			Festivalin tahsis ettiği bir otopark alanı bulunmamaktadır. 
		`,
	},
	{
		title: 'Giriş Saati',
		description: `
			Festival alanına girişler her gün 14:00'da başlayacaktır.
		`,
	},
	{
		title: 'Bileklik',
		description: `
			Festival alanına giriş yapabilmek için kombine veya tek gün bilekliklerinin takılması zorunludur. Bileklikler sadece satın alan kişi tarafından kullanılabilir ve başka kişilere devredilemez. Ayrıca bilekliklerin kaybedilmesi veya çalınması durumunda yenisi çıkarılmaz ve festival alanına tekrar giriş yapılamaz. Katılımcıların alandan çıkması yasaktır. Aynı gün içerisinde alandan çıkılması durumunda tekrar içeri girilebilmesi için yeniden bilet almak zorundadır.
		`,
	},
	{
		title: 'Ulaşım',
		description: `
			CerModern'e ulaşmak çok kolay. CerModern'e ister yaya, ister otobüs veya metro ile çok rahat ulaşabilirsiniz. Sıhhiye metro durağı ve Adliye metro durakları, Gençlik Parkı ve Adliye otobüs duraklarına 10 dk. yürüme mesafesindedir. Detaylı bilgi için <a class="hyperlink" target="_blank" rel="noopener noreferrer" href="https://ego.gov.tr">ego.gov.tr</a> adresine bakabilirsiniz.
		`,
	},
];

export default ifPayFaqs;